import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../stores/useAuthStore";
import { CheckoutLayout } from "./CheckoutLayout";
import { XCircle } from "lucide-react";

const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export function CheckoutFailed() {
  const navigate = useNavigate();
  const { tableId, tenant } = useAuthStore();
  const entryToken = localStorage.getItem('kiero_entry_token')
    || getCookie('kiero_entry_token')
    || sessionStorage.getItem('entry_token');
  const isKiero = !!entryToken || tenant?.partner_branding === 'KIERO';

  return (
    <CheckoutLayout
      title="Pago Fallido"
      icon={<XCircle className="w-12 h-12" />}
      message="Error en el pago"
      description="Lo sentimos, hubo un problema al procesar tu pago. Por favor, intenta nuevamente."
      iconBgColor="bg-red-100 dark:bg-red-900/20"
      iconTextColor="text-red-600 dark:text-red-400"
      actionButton={
        <button
          onClick={() => {
            if (entryToken) {
              navigate(`/simple-menu/${entryToken}`);
            } else {
              navigate(`/payment/${tableId || ""}`);
            }
          }}
          className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-lg font-medium transition-colors"
        >
          {isKiero ? "Volver al Menú" : "Reintentar Pago"}
        </button>
      }
    />
  );
}